import React from "react";

const Loader = () => {
  return (
    <div className="loader">
      <div className="circle green"></div>
      <div className="circle white"></div>
      <div className="circle green"></div>
    </div>
  );
};

export default Loader;
